import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';
import { NarrowCentredContent } from 'features/Onboarding/styles';

import Page from '../Page';
import Horn from './assets/Horn@2x.png';
import { ActionButtonWrapper, Title } from './styles';
import { StageSuccessPageProps } from './types';

const StageSuccessPage: FC<StageSuccessPageProps> = ({
  actionButton,
  arrowButton,
  bottomContent = null,
  description,
  title,
  ...pageProps
}) => (
  <Page {...pageProps}>
    <OnboardingPageContent>
      <NarrowCentredContent>
        <Image boxSize="180px" marginX="auto" src={Horn} />

        <Title>{title}</Title>

        {typeof description === 'string' ? (
          <Text variant="primary">{description}</Text>
        ) : (
          description
        )}

        {arrowButton ? (
          <Button
            icon="chevron-right"
            marginTop="space-24"
            onClick={arrowButton.onPress}
            variant="inline-primary"
          >
            {arrowButton.label}
          </Button>
        ) : null}

        {actionButton ? (
          <ActionButtonWrapper>
            <Button isExpanded onClick={actionButton.onPress}>
              {actionButton.label}
            </Button>
          </ActionButtonWrapper>
        ) : null}
      </NarrowCentredContent>

      {bottomContent}
    </OnboardingPageContent>
  </Page>
);

export default StageSuccessPage;
